<template>
    <div
        class="toast-container"
        :class="[
            `padding_${containerPadding}`,
            `radius_${radius}`,
            `color_${color}`,
            fullWidth && 'fullWidth',
            border && `border_${color}`,
            columnMobile && 'break',
            color === 'white' && 'border', // TODO! Add a property instead...
        ]">
        <Illustration
            v-if="illustration && !icon"
            :data="illustration"
            class="illustration" />
        <Asset v-if="asset" :type="asset" class="asset" />
        <Icon
            v-if="icon && !asset"
            class="icon"
            :type="icon"
            :size="iconSize"
            :rotate="iconRotate"
            :color="iconColor" />

        <div class="toast-inner">
            <div class="toast-title" v-if="title || subTitle">
                <h3 v-if="title" class="toast-title-main">{{ title }}</h3>
                <span v-if="subTitle" class="toast-title-sub">
                    {{ subTitle }}
                </span>
            </div>

            <slot />
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType, computed } from 'vue';
    import { Padding, Radius, Color } from './Toast.interfaces';
    import {
        Type as IconType,
        Size as IconSize,
        Color as IconColor,
    } from '@ui/components/Icon/Icon.interfaces';
    import { Type as AssetType } from '@ui/components/Asset/Asset.interfaces';
    import { IllustrationData } from '../Illustration/Illustration.interfaces';
    import { useScreenSize } from '@shared/helpers/viewport';
    import Asset from '@ui/components/Asset/Asset.vue';
    import Icon from '@ui/components/Icon/Icon.vue';
    import Illustration from '../Illustration/Illustration.vue';

    export default defineComponent({
        name: 'Toast',
        components: { Asset, Icon, Illustration },
        props: {
            title: String,
            subTitle: String,
            padding: {
                type: String as PropType<Padding>,
            },
            radius: {
                type: String as PropType<Radius>,
                default: 's',
            },
            color: {
                type: String as PropType<Color>,
                default: 'yellow',
            },
            fullWidth: {
                type: Boolean,
                default: false,
            },
            columnMobile: {
                type: Boolean,
                default: false,
            },
            illustration: {
                type: Object as PropType<IllustrationData>,
            },
            asset: {
                type: String as PropType<AssetType>,
            },
            icon: {
                type: String as PropType<IconType | null>,
                default: null,
            },
            iconSize: {
                type: String as PropType<IconSize>,
                default: 's',
            },
            iconRotate: Number,
            iconColor: {
                type: String as PropType<IconColor>,
            },
            border: {
                type: Boolean,
                default: false,
            },
        },

        setup(props) {
            const { isDesktop } = useScreenSize();

            const containerPadding = computed(() =>
                props.padding ? props.padding : isDesktop.value ? 'l' : 'm'
            );

            return { containerPadding };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Toast.scss';
</style>
